import { ComponentType } from 'react';

import { ComposeProvider } from '@Components/shared/providers/ComposeProvider';

// Providers
import { CreateProviderFormProvider } from '@Features/providers/forms/providers/CreateProviderFormProvider';
import { SetupProviderFormProvider } from '@Features/providers/forms/providers/SetupProviderFormProvider';

// Rounds
import { CreateRoundConfigFormProvider } from '@Features/providers/forms/rounds/CreateRoundConfigFormProvider';

// AviatorUsers
import { CreateAviatorUserFormProvider } from '@Features/providers/forms/roles/CreateAviatorUserFormProvider';

// AviatorRoles
import { CreateAviatorRoleFormProvider } from '@Features/providers/forms/aviatorRoles/CreateAviatorRoleFormProvider';
import { CreateProviderConfigFormProvider } from '@Features/providers/forms/providers/CreateProviderConfigFormProvider';
import { CreateAviatorPermissionFormProvider } from '@Features/providers/forms/aviatorPermissions/CreateAviatorPermissionFormProvider';
import { AddRolePermissionsFormProvider } from '@Features/providers/forms/aviatorPermissions/AddRolePermissionsFormProvider';
// Localizations
import { CreateLocalizationKeyFormProvider } from '@Features/providers/forms/localizations/CreateLocalizationKeyFormProvider';
import { UpdateProviderConfigFormProvider } from '@Features/providers/forms/providers/UpdateProviderConfigFormProvider';
import { UpdateMinesProviderConfigFormProvider } from '@Features/providers/forms/providers/UpdateMinesProviderConfigFormProvider';
import { TestsFormProvider } from '@Features/providers/forms/tests/TestsFormProvider';
import { TransactionExportFormProvider } from '@Features/providers/forms/transactions/TransactionExportFormProvider';
import { CreateRaindropFormProvider } from '@Features/providers/forms/raindrop/CreateRaindropFormProvider';

const providers: ComponentType<{ children: JSX.Element }>[] = [
  CreateProviderFormProvider,
  SetupProviderFormProvider,
  CreateRoundConfigFormProvider,
  CreateAviatorUserFormProvider,
  CreateAviatorRoleFormProvider,
  CreateProviderConfigFormProvider,
  UpdateProviderConfigFormProvider,
  UpdateMinesProviderConfigFormProvider,
  CreateAviatorPermissionFormProvider,
  AddRolePermissionsFormProvider,
  CreateLocalizationKeyFormProvider,
  TestsFormProvider,
  TransactionExportFormProvider,
  CreateRaindropFormProvider,
];

type Props = { children: JSX.Element | JSX.Element[] };

export const StoreContainer: React.FC<Props> = ({ children }) => {
  return (
    <ComposeProvider providers={providers}>
      <>{children}</>
    </ComposeProvider>
  );
};
